module.exports = __webpack_public_path__ + "img/retail.4597da8e.jpg";